module.exports = __webpack_public_path__ + "img/section2-patern.975187ab.svg";